"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _TimePickers = require("./TimePickers.helpers");
var _PCView = require("./partials/PCView");
var _MobileView = require("./partials/MobileView");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getValidProps = props => {
  const {
    minHour: minHourProp,
    maxHour: maxHourProp,
    minMinute: minMinuteProp,
    maxMinute: maxMinuteProp,
    defaultTime,
    minutesStep = 1
  } = props;
  let {
    hours,
    minutes
  } = (0, _TimePickers.extractTimeParts)(defaultTime);
  const maxHour = minHourProp && maxHourProp && minHourProp > maxHourProp ? minHourProp : maxHourProp;
  const maxMinute = minMinuteProp && maxMinuteProp && minMinuteProp > maxMinuteProp ? minMinuteProp : maxMinuteProp;
  hours = typeof minHourProp === 'number' && hours < minHourProp ? minHourProp : hours;
  hours = typeof maxHour === 'number' && hours > maxHour ? maxHour : hours;
  minutes = typeof minMinuteProp === 'number' && minutes < minMinuteProp ? minMinuteProp : minutes;
  minutes = typeof maxMinute === 'number' && minutes > maxMinute ? maxMinute : minutes;
  if (typeof minutesStep === 'number' && minutesStep > 1 && minutes % minutesStep > 0) {
    minutes = Math.ceil(minutes / minutesStep) * minutesStep % 60;
  }
  return {
    ...props,
    maxHour,
    maxMinute,
    defaultHour: hours,
    defaultMinute: minutes
  };
};
const TimePicker = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    minHour,
    maxHour,
    minMinute,
    maxMinute,
    minutesStep,
    defaultTime,
    defaultHour,
    defaultMinute,
    onChange
  } = getValidProps(props);
  const hourOptions = (0, _react.useMemo)(() => (0, _TimePickers.generateHourOptions)(minHour, maxHour), [minHour, maxHour]);
  const minutesOptions = (0, _react.useMemo)(() => (0, _TimePickers.generateMinutesOptions)(minMinute, maxMinute, minutesStep), [minMinute, maxMinute, minutesStep]);
  const defaultHourOption = (0, _react.useMemo)(() => hourOptions.find(o => o.value === defaultHour) || hourOptions[0], [hourOptions, defaultHour]);
  const defaultMinuteOption = (0, _react.useMemo)(() => minutesOptions.find(o => o.value === defaultMinute) || minutesOptions[0], [minutesOptions, defaultMinute]);
  const [selectedHourOption, setSelectedHourOption] = (0, _react.useState)(defaultHourOption);
  const [selectedMinuteOption, setSelectedMinuteOption] = (0, _react.useState)(defaultMinuteOption);
  const handleTimeChange = (hour, minute) => {
    const selectedHour = typeof hour !== 'undefined' ? hour : selectedHourOption?.value ?? 0;
    const selectedMinute = typeof minute !== 'undefined' ? minute : selectedMinuteOption?.value ?? 0;
    setSelectedHourOption(hourOptions?.find(o => o.value === selectedHour) || hourOptions?.[0]);
    setSelectedMinuteOption(minutesOptions?.find(o => o.value === selectedMinute) || minutesOptions?.[0]);
    if (onChange) {
      const dateTime = typeof defaultTime === 'object' ? new Date(defaultTime) : new Date();
      dateTime.setHours(selectedHour);
      dateTime.setMinutes(selectedMinute);
      onChange(selectedHour, selectedMinute, dateTime);
    }
  };
  (0, _react.useEffect)(() => {
    setSelectedHourOption(hourOptions?.find(o => o.value === defaultHour) || hourOptions?.[0]);
    setSelectedMinuteOption(minutesOptions?.find(o => o.value === defaultMinute) || minutesOptions?.[0]);
  }, [defaultHour, defaultMinute, hourOptions, minutesOptions]);
  if (!selectedHourOption || !selectedMinuteOption) {
    return null;
  }
  return isMobileView ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MobileView.MobileView, {
    hourOptions: hourOptions,
    minutesOptions: minutesOptions,
    defaultHourOption: selectedHourOption,
    defaultMinuteOption: selectedMinuteOption,
    onTimeChange: handleTimeChange
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_PCView.PcView, {
    hourOptions: hourOptions,
    minutesOptions: minutesOptions,
    defaultHourOption: selectedHourOption,
    defaultMinuteOption: selectedMinuteOption,
    onTimeChange: handleTimeChange
  });
};
exports.TimePicker = TimePicker;